import createAxiosInstance from "../../utils/axiosInstance";

export const getCourse = async (payload) => {
  try {
    const axiosInstance = createAxiosInstance(payload.accessToken);
    const response      = await axiosInstance.get(`/courses/${payload.courseId}`);
    return response.data;
  } catch(err) {
    console.log(err);
  }
}

export const getEnrolledCourses = async (accessToken, params, postParams) => {
  let url = '/enrolled-courses';
  const queryParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const axiosInstance = createAxiosInstance(accessToken);
    const response      = await axiosInstance.post(url, postParams);
    return response.data;
  } catch(err) {
    console.log(err);
  }
}

export const getEnrolledContents = async (payload) => {
  try {
    const axiosInstance = createAxiosInstance(payload.accessToken);
    const response      = await axiosInstance.get(`/enrolled-courses/${payload.slug}`);
    return response.data;
  } catch(err) {
    console.log(err);
  }
}

export const getCompletedCourses = async (accessToken, params, postParams) => {
  let url = '/enrolled-courses';
  const queryParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const axiosInstance = createAxiosInstance(accessToken);
    const response      = await axiosInstance.post(url, postParams);
    return response.data.data;
  } catch(err) {
    console.log(err);
  }
}

export const postCourseReview = async (accessToken, params) => {
  let host = window.location.protocol + "//" + window.location.host + '/api/courses';
  let url  = '/rating';
  
  try {
    const axiosInstance = createAxiosInstance(accessToken, host);
    const response      = await axiosInstance.post(url, params);
    return response.data;
  } catch(err) {
    console.log(err);
  }
}

export const getEnrolledSubjectReport = async (accessToken, params) => {
  let host = window.location.protocol + "//" + window.location.host + '/api/v1';
  let url = '/subject_progress';

  try {
    const axiosInstance = createAxiosInstance(accessToken, host);
    const response      = await axiosInstance.post(url, params);
    return response.data;
  } catch(err) {
    console.log(err);
  }
}